import { asLabel } from '@shure/shared/models';

export type NavigationItems = {
	icon: string;
	label: string;
	disabled: boolean;
	route: string;
	selected: boolean;
	labelId: string;
	applicationType: ApplicationType;
	navigateUrl?: string;
};
export enum ApplicationType {
	CloudDeviceManagement = 'cloud-device-management',
	OrganizationPortal = 'organization-portal'
}
export const navItems: NavigationItems[] = [
	{
		icon: 'home',
		label: asLabel('cloud.shure-cloud.home'),
		disabled: false,
		route: 'home',
		labelId: 'home',
		selected: false,
		applicationType: ApplicationType.OrganizationPortal
	},
	{
		icon: 'apps',
		label: asLabel('cloud.shure-cloud.apps'),
		disabled: false,
		route: 'apps',
		labelId: 'apps',
		selected: false,
		applicationType: ApplicationType.OrganizationPortal
	},
	{
		icon: 'sh-devices',
		label: asLabel('cloud.shure-cloud.devices'),
		disabled: false,
		route: 'devices',
		labelId: 'devices',
		selected: false,
		applicationType: ApplicationType.CloudDeviceManagement
	},
	{
		icon: 'sh-license',
		label: asLabel('cloud.shure-cloud.license-management.licenses'),
		disabled: false,
		route: 'licenses',
		labelId: 'licenses',
		selected: false,
		applicationType: ApplicationType.OrganizationPortal
	},
	{
		icon: 'group',
		label: asLabel('cloud.shure-cloud.users.users'),
		disabled: false,
		route: 'user-management',
		labelId: 'users',
		selected: false,
		applicationType: ApplicationType.OrganizationPortal
	},
	{
		icon: 'sh-eventlog',
		label: asLabel('cloud.shure-cloud.event-log.event-log'),
		disabled: false,
		route: 'event-log',
		labelId: 'event',
		selected: false,
		applicationType: ApplicationType.OrganizationPortal
	},
	{
		icon: 'settings',
		label: asLabel('cloud.shure-cloud.org-settings.organization-settings'),
		disabled: false,
		route: 'organization-settings',
		labelId: 'org-settings',
		selected: false,
		applicationType: ApplicationType.OrganizationPortal
	}
];
